export default defineAppConfig({
  auth: {
    providers: ['email', 'discord', 'google', 'facebook'],
  },
})
